import React, { Component } from "react";
import { Link } from "react-router-dom";

import UI from "../../../actions/ui-helper";
import StringUtil from "../../../actions/string";

class ConsultaPacienteResultado extends Component {

  componentWillUpdate() {
    UI.destroyTable(this.tableId);
  }

  componentDidUpdate() {
    UI.dataTable(this.tableId);
  }

  render() {
    if (this.props.resultado.length === 0) {
      return false;
    }
    this.tableId = StringUtil.uuid(5);

    return (
      <div className="row">
        <div className="col-12 grid-margin">
          <div className="row">
            <div className="col-12 table-responsive">
              <table key={StringUtil.uuid(5)} id={this.tableId} className="table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>ID Cismepar</th>
                    <th>Data Nascimento</th>
                    <th>Nome</th>
                    <th>Cidade</th>
                    <th>Opções</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.resultado.map((paciente, i) => {
                    return (
                      <tr key={paciente.id}>
                        <td>{paciente.id}</td>
                        <td>{paciente.idCismepar}</td>
                        <td>{paciente.dataNascimento}</td>
                        <td>{paciente.nome}</td>
                        <td>{paciente.endereco.cidade}</td>
                        <td>
                          <div className="dropdown">
                            <button className="btn btn-xs btn-light icon-btn btn-option" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              <i className="fa fa-cog"></i>
                            </button>
                            <div className="dropdown-menu">
                              <Link
                                to={"/paciente/cadastro/" + paciente.id}
                                className="dropdown-item"><i className="fa fa-edit"></i>&nbsp;Editar</Link>
                              <Link
                                to={"/paciente/prontuario/" + paciente.id}
                                className="dropdown-item"><i className="fa fa-paperclip"></i>&nbsp;Prontuário</Link>
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ConsultaPacienteResultado;
